(function () {

    if (window.__cartSyncLoaded) return;
    window.__cartSyncLoaded = true;

    console.log('Cart Sync Script Loaded');

    /* ============================= */
    /* CONFIG & STATE */
    const cartPending = {};
    const parser = new DOMParser();

    /* ============================= */
    /* BUTTON CLICK HANDLER */
    window.adjustQty = function (button, change) {
        console.log('Button clicked', change);
        
        const wrapper = button.closest('.product-card__qty');
        if (!wrapper) return;

        const available = wrapper.dataset.available === "true";
        if (!available) return;

        const input = wrapper.querySelector('.quantity-input');
        const variantId = wrapper.dataset.variantId;

        let qty = parseInt(input.value) || 0;
        qty = Math.max(0, qty + change);

        // Instant UI update for the input field
        input.value = qty;

        syncCart(variantId, qty, wrapper);
    };

    /* ============================= */
    /* MAIN SYNC LOGIC */
    function syncCart(variantId, qty, wrapper) {

        // Queue requests for the same variant
        if (cartPending[variantId]) {
            cartPending[variantId].pendingQty = qty;
            return;
        }

        cartPending[variantId] = { pendingQty: qty };
        
        wrapper.classList.add('is-loading');

        const root = window.Shopify?.routes?.root || '/';

        // 1. Get current cart to decide ADD vs CHANGE
        fetch(`${root}cart.js?v=${new Date().getTime()}`)
            .then(r => r.json())
            .then(cart => {
                const item = cart.items.find(i => String(i.variant_id) === String(variantId));
                
                let url = (qty === 0 || item) ? 'cart/change.js' : 'cart/add.js';
                let body = {
                    id: (item ? (item.key || item.id) : parseInt(variantId)),
                    quantity: qty
                };

                console.log(`Syncing: ${url}`, body);

                return fetch(root + url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                });
            })
            .then(r => r.json())
            .then(response => {
                wrapper.classList.remove('is-loading');
                console.log('Server response:', response);

                const pending = cartPending[variantId];
                delete cartPending[variantId];

                // Process queued requests
                if (pending && pending.pendingQty !== qty) {
                    syncCart(variantId, pending.pendingQty, wrapper);
                    return;
                }

                // Trigger Fresh UI Refresh
                refreshUI();

                // Show success message
                showMsg(wrapper);
            })
            .catch(err => {
                wrapper.classList.remove('is-loading');
                delete cartPending[variantId];
                console.error('Cart SYNC error:', err);
            });
    }

    /* ============================= */
    /* ROBUST UI REFRESH */
    function refreshUI() {
        const root = window.Shopify?.routes?.root || '/';
        const sectionsUrl = `${root}?sections=cart-drawer,cart-icon-bubble`;
        
        console.log('Refreshing UI sections from:', sectionsUrl);

        fetch(sectionsUrl)
            .then(r => r.json())
            .then(sections => {
                console.log('Received sections');

                // 1. Update Cart Bubble (Count)
                const iconContainer = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
                if (iconContainer && sections['cart-icon-bubble']) {
                    const html = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
                    const newBubble = html.querySelector('.cart-count-bubble') || html.querySelector('#cart-icon-bubble');
                    const currentBubble = iconContainer.querySelector('.cart-count-bubble') || iconContainer.querySelector('#cart-icon-bubble');

                    if (currentBubble && newBubble) {
                        currentBubble.outerHTML = newBubble.outerHTML;
                    } else if (newBubble) {
                        // If bubble didn't exist (0 items), inject it
                        iconContainer.insertAdjacentHTML('beforeend', newBubble.outerHTML);
                    } else if (currentBubble) {
                        // If it should be hidden (now 0)
                        currentBubble.remove();
                    }
                }

                // 2. Update Cart Drawer Listing
                const drawer = document.querySelector('cart-drawer');
                if (drawer && sections['cart-drawer']) {
                    const html = parser.parseFromString(sections['cart-drawer'], 'text/html');
                    const newDrawer = html.querySelector('cart-drawer') || html.body.firstChild;
                    
                    if (newDrawer) {
                        // Update internal content and classes
                        drawer.innerHTML = newDrawer.innerHTML;
                        drawer.className = newDrawer.className;
                        
                        // Force listing visibility if items > 0
                        if (drawer.classList.contains('is-empty') && drawer.querySelector('.drawer__inner')) {
                             // Double check if it should really be empty
                             // (Dawn uses server-side logic, but we can override if needed)
                        }
                    }
                }

                // 3. Keep page inputs in sync
                syncAllCards();
            });
    }

    /* ============================= */
    /* SYNC ALL QUANTITY INPUTS */
    function syncAllCards() {
        const root = window.Shopify?.routes?.root || '/';
        fetch(`${root}cart.js?v=${new Date().getTime()}`)
            .then(r => r.json())
            .then(cart => {
                document.querySelectorAll('.product-card__qty').forEach(wrapper => {
                    const variantId = wrapper.dataset.variantId;
                    const input = wrapper.querySelector('.quantity-input');
                    const item = cart.items.find(i => String(i.variant_id) === String(variantId));
                    if (input) input.value = item ? item.quantity : 0;
                });
            })
            .catch(() => {});
    }

    /* ============================= */
    /* FEEDBACK MSG */
    function showMsg(wrapper) {
        const msg = wrapper?.parentElement?.querySelector('.cart-msg');
        if (msg) {
            msg.classList.remove('hidden');
            setTimeout(() => msg.classList.add('hidden'), 2000);
        }
    }

    /* ============================= */
    /* INITIALIZE */
    function init() {
        console.log('Initializing Cart Sync');
        syncAllCards();
        
        // Watch for drawer modifications to ensure cards stay in sync
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
            const observer = new MutationObserver(syncAllCards);
            observer.observe(drawer, { childList: true, subtree: true });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.addEventListener('pageshow', function (e) {
        if (e.persisted) syncAllCards();
    });

})();
